import React from 'react'
import {StackNavigationProp} from '@react-navigation/stack'

import {StateSelectGQLContainer} from 'src/products/general/StateSelect/StateSelectGQLContainer'
import {MainStackParamList} from 'src/nav/MainStackParamsList'

type StateSelectGoogleAuthContainerProps = {
  navigation: StackNavigationProp<MainStackParamList>
}

/**
 * StateSelectGoogleAuthContainer is used to handle state selection for the GoogleAuth flow because
 * google doesn't return the users state.
 */
const StateSelectGoogleAuthContainer = ({
  navigation,
}: StateSelectGoogleAuthContainerProps): JSX.Element => {
  const handleOnComplete = async (): Promise<void> => {
    return new Promise((resolve) => {
      navigation.navigate('SignupWorkflow', {screen: 'Loading', initial: false})

      resolve()
    })
  }

  return <StateSelectGQLContainer onComplete={handleOnComplete} />
}

export {StateSelectGoogleAuthContainer}
